import React from 'react';
import './SharedComponents.css';

export const ParameterCard = ({ 
  name, 
  value, 
  min, 
  max, 
  current, 
  unit, 
  status, 
  onChange 
}) => {
  const percentage = ((current - min) / (max - min)) * 100;
  
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <div className="parameter-card">
      <h3>{name}</h3>
      <div className="value">{value}</div>
      <div className="gauge">
        <div className="gauge-fill" style={{ width: `${percentage}%` }}></div>
        <div className="gauge-labels">
          <span>{min}{unit}</span>
          <span>{max}{unit}</span>
        </div>
      </div>
      <div className="parameter-control">
        <input 
          type="range"
          min={min}
          max={max}
          value={current}
          onChange={handleChange}
          step={0.1}
        />
      </div>
      {status && <div className={`status ${status}`}>
        {status === 'safe' ? 'Optimal' : 'Warning'}
      </div>}
    </div>
  );
};